import { render, staticRenderFns } from "./platformDetail.vue?vue&type=template&id=824e4d00&scoped=true&"
import script from "./platformDetail.vue?vue&type=script&lang=js&"
export * from "./platformDetail.vue?vue&type=script&lang=js&"
import style0 from "./platformDetail.vue?vue&type=style&index=0&id=824e4d00&lang=less&scoped=true&"
import style1 from "./platformDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824e4d00",
  null
  
)

export default component.exports